import { render, staticRenderFns } from "./DocumentBeneficiaire.vue?vue&type=template&id=8a91855c&"
import script from "./DocumentBeneficiaire.vue?vue&type=script&lang=ts&"
export * from "./DocumentBeneficiaire.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports